exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rexer_events__container{padding-bottom:2rem;margin-bottom:2rem}.fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}.rexer_events__loading{text-align:center}\n", ""]);

// exports
